import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosConfig"; // Assuming you have this global axios config
import PasswordInput from "./PasswordInput";

const RegisterDirector = () => {
  // State for all form fields
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    password: "Aionion@123", // Default password as in your original code
    location: "",
  });

  // State for handling loading, success, and error messages
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- THIS IS THE CORRECTED FUNCTIONALITY ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setIsError(false);

    try {
      // 1. THE SINGLE, CORRECT API CALL
      // We send ONE request to the generic endpoint with the role in the URL.
      // The backend will handle everything in a single, safe transaction.
      const response = await api.post("/api/admin/register/director", {
        name: formData.name,
        username: formData.username,
        email: formData.email,
        password: formData.password,
        location: formData.location,
      });

      // 2. HANDLE SUCCESS
      setMessage(
        response.data.message || "Sales Head registered successfully!"
      );
      setIsError(false); // Ensure message is shown as success

      // Clear the form fields
      setFormData({
        name: "",
        username: "",
        email: "",
        password: "Aionion@123",
        location: "",
      });

      // Redirect back to the dashboard after a short delay
      setTimeout(() => navigate("/admin-dashboard"), 2000);
    } catch (err) {
      // 3. HANDLE ERRORS
      // The backend will send a specific error message if validation fails
      console.error(err);
      setMessage(err.response?.data?.message || "Error registering Sales Head");
      setIsError(true); // Ensure message is shown as an error
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-form">
      <h2>Register Sales Head</h2>

      {/* Dynamic message display for success or error */}
      {message && (
        <div className={`alert ${isError ? "alert-danger" : "alert-success"}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="username" className="form-label">
            Username
          </label>
          <input
            type="text"
            className="form-control"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </div>

        <PasswordInput
          label="Password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          disabled={loading}
        />

        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="location" className="form-label">
            Location *
          </label>
          <select
            className="form-select location-select"
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            required
            disabled={loading}
          >
            <option value="">Select Location</option>
            <option value="Chennai">Chennai</option>
            <option value="Trichy">Trichy</option>
            <option value="Coimbatore">Coimbatore</option>
            <option value="Bangalore">Bangalore</option>
            <option value="Dubai">Dubai</option>
            <option value="Singapore">Singapore</option>
            <option value="Madurai">Madurai</option>
          </select>
        </div>

        <div className="btn-container">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Registering..." : "Register Sales Head"}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate("/admin-dashboard")}
            disabled={loading}
          >
            Back to Dashboard
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegisterDirector;
